import { render, staticRenderFns } from "./NCardItem.vue?vue&type=template&id=06f87890&scoped=true&"
import script from "./NCardItem.vue?vue&type=script&lang=js&"
export * from "./NCardItem.vue?vue&type=script&lang=js&"
import style0 from "./NCardItem.vue?vue&type=style&index=0&id=06f87890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f87890",
  null
  
)

export default component.exports